import React from "react";
import SectionTitle from "./SectionTitle";
import { MdCode, MdDesktopMac, MdDns } from "react-icons/md";
import ServicesSectionitem from "../components/ServiceSectionItem";

export default function ServicesSection() {
  return (
    <div className="ServicesSection">
      <SectionTitle
        className="section-title"
        heading="Services"
        subheading="What I Can Do For You"
      />
      <div className="services__allitems">
        <ServicesSectionitem
          icon={<MdDesktopMac />}
          desc="I do UI/UX design for user to get a uniques experience and interaction with sites"
          title="Web Design"
        />
        <ServicesSectionitem
          icon={<MdCode />}
          desc="I am experienced with developing websites for large firms and businesses. I focus more on high performance websites with blaxzing speed and seo ranking"
          title="Web Dev"
        />
        <ServicesSectionitem
          icon={<MdDns />}
          desc="I work majorly and provide Backend service for users and site owners working on various backend side, logic , and auth"
          title="Backend Dev"
        />
      </div>
    </div>
  );
}
